import React from 'react';
import { ArrowDropDown } from '@material-ui/icons';
import { makeStyles, InputAdornment, Box, Typography } from '@material-ui/core';
import { mapCountryToFlag } from '@klp/leverandor/utils';
import type { COUNTRY_MENU_OPTION } from '@klp/leverandor/types';

const useStyles = makeStyles((theme) => ({
    countrySelector: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        padding: theme.spacing(0, 1),
        borderRight: `1px solid ${theme.palette.divider}`,
        marginRight: theme.spacing(1),
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    countryFlag: {
        fontSize: '1.25rem',
    },
}));

interface CountryAdornmentProps {
    country: COUNTRY_MENU_OPTION | undefined;
    setCountryMenuAnchor: React.Dispatch<
        React.SetStateAction<null | HTMLElement>
    >;
}

export const CountryAdornment = ({
    country,
    setCountryMenuAnchor,
}: CountryAdornmentProps) => {
    const classes = useStyles();

    const handleCountryMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setCountryMenuAnchor(event.currentTarget);
    };

    return (
        <InputAdornment position="start">
            <Box
                className={classes.countrySelector}
                onClick={handleCountryMenuOpen}
            >
                <Typography className={classes.countryFlag}>
                    {mapCountryToFlag(country)}
                </Typography>
                <ArrowDropDown fontSize="small" />
            </Box>
        </InputAdornment>
    );
};
